<template>
  <div class="tabs-container ng-scope" style="padding-bottom: 50px; margin-top: 18px">
    <div id="wrapperp">
      <ul class="nav nav-tabs">
        <li class="tabLi" v-for="(data, $index) in langData" :key="$index" :class="{ 'active': $index == 0 }">
          <div class="tabDiv" @click="changeTab($index)"></div>
          <a :class="true ? 'tab' + $index : ''" data-toggle="tab" :href="true ? '#tab-' + $index : ''" aria-expanded="true" @click="showTab($event, $index)">{{ $t("message." + data) }}</a>
        </li>
      </ul>
    </div>
    <el-form :model="editorialDetail" ref="editorialDetail" label-width="0px" class="demo-dynamic form-horizontal detailPage">
      <div class="tab-content">
        <div :id="'tab-' + index" v-for="(langItem, index) in editorialDetail.langMap" :key="index" class="tab-pane">
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label"> Popular </label>
                <div class="col-sm-4" style="padding-top: 7px">
                  <el-switch v-model="editorialDetail.popular"> </el-switch>
                </div>
                <label class="col-sm-2 control-label"> Location </label>
                <div class="col-sm-4">
                  <el-form-item
                    prop="location"
                    :rules="{
                      required: false,
                      message: $t('message.required'),
                      trigger: 'change',
                    }"
                  >
                    <el-select v-model="editorialDetail.location" multiple clearable>
                      <el-option v-for="item in locationList" :key="item.id + ''" :label="getObject(item.langMap, langItem.langCode).content" :value="item.id + ''"> </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Card Type </label>
                <div class="col-sm-4">
                  <el-form-item
                    prop="type"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'change',
                    }"
                  >
                    <el-select v-model="editorialDetail.type" clearable @change="changeType">
                      <el-option v-for="item in typeObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Card Title</label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'langMap.' + index + '.cardTitle'"
                    :rules="{
                      required: false,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input v-model="langItem.cardTitle"></el-input>
                  </el-form-item>
                  <p class="tip">(optimal length: 32 characters)</p>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Editorial Title<span style="color: red">*</span> </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'langMap.' + index + '.editorialTitle'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input v-model="langItem.editorialTitle" show-word-limit></el-input>
                  </el-form-item>
                  <p class="tip">(optimal length: 32 characters)</p>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Image<span style="color: red">*</span> </label>
                <div class="col-sm-5">
                  <el-form-item
                    :prop="'langMap.' + index + '.image'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'change',
                    }"
                  >
                    <el-input v-model="langItem.image" :change="setImage(editorialDetail.langMap, langItem.image, 'image')" style="display: none"></el-input>
                    <file-upload :fileUploadUrl="fileUploadUrl" :limit="5" v-model="langItem.image">
                      <template v-slot:sizeError>
                        <div style="color: red">Size error!</div>
                      </template>
                      <template v-slot:dimensionError>
                        <div style="color: red">Dimension Error!</div>
                      </template>
                      <template v-slot:sizeHint>
                        <div style="font-size: 12px">(Sugguest Size: 1200 X 750 )</div>
                        <div>Max 5 MB.</div>
                      </template>
                    </file-upload>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Caption </label>
                <div class="col-sm-10">
                  <el-input v-model="langItem.caption" show-word-limit></el-input>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> AltText </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'langMap.' + index + '.altText'"
                    :rules="{
                      required: false,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input v-model="langItem.altText" show-word-limit></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label"> Preferences </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="preferencesLink"
                    :rules="{
                      required: false,
                      message: $t('message.required'),
                      trigger: 'change',
                    }"
                  >
                    <el-select v-model="editorialDetail.preferencesLink" multiple filterable clearable>
                      <el-option v-for="item in preferencesObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Start Date </label>
                <div class="col-sm-4">
                  <el-form-item
                    prop="startTime"
                    :rules="{
                      required: false,
                      message: $t('message.required'),
                      trigger: 'change',
                    }"
                  >
                    <el-date-picker v-model="editorialDetail.startTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="startTime"> </el-date-picker>
                  </el-form-item>
                </div>
                <label class="col-sm-2 control-label"> End Date </label>
                <div class="col-sm-4">
                  <el-form-item
                    prop="endTime"
                    :rules="{
                      required: false,
                      message: $t('message.required'),
                      trigger: 'change',
                    }"
                  >
                    <el-date-picker v-model="editorialDetail.endTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="endTime"> </el-date-picker>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Status<span style="color: red">*</span> </label>
                <div class="col-sm-4">
                  <el-form-item
                    prop="status"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'change',
                    }"
                  >
                    <el-select v-model="editorialDetail.status" clearable>
                      <el-option v-for="item in statusObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <div style="padding-bottom: 10px">This editorial is for the following member tier</div>
                <label class="col-sm-2 control-label">Member tier </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="membershipIds"
                    :rules="{
                      required: $route.query.isMandatory ? true : false,
                      message: $t('message.required'),
                      trigger: 'change',
                    }"
                  >
                    <el-select v-model="editorialDetail.membershipIds" clearable multiple>
                      <el-option v-for="item in membershipList" :key="item.id" :label="item.membershipName" :value="item.id"> </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group" v-if="editorialDetail.type == 1">
                <div class="col-sm-12">
                  <draggable class="" style="margin-bottom: 15px" v-model="editorialDetail.modules" group="1" @start="drag = true" @end="drag = false">
                    <div v-for="(item, index) in editorialDetail.modules" class="dragObj categoryDrag">
                      <el-collapse v-model="activeNamesBasis">
                        <el-collapse-item :title="item.moduleName" :name="index">
                          <div v-for="(lang, i) in item.langMap" v-if="lang.langCode == langItem.langCode">
                            <div class="form-group" v-if="item.moduleId == 1 || item.moduleId == 2">
                              <div class="col-sm-12 pad-b-15">
                                <ckeditor :editor="editor" @ready="onReady" v-model="lang.content" :config="editorConfig"></ckeditor>
                                <p style="color: red" v-if="item.moduleId == 2">Please avoid using special characters (eg: !@#$%^&*[]<>「」『』) to start a sentence</p>
                              </div>
                            </div>
                            <div class="form-group" v-if="item.moduleId == 3">
                              <div class="col-sm-12 pad-b-15">
                                <el-input v-model="lang.content" show-word-limit></el-input>
                              </div>
                            </div>
                            <div class="form-group" v-if="item.moduleId == 4">
                              <label class="col-sm-2 control-label"> Image </label>
                              <div class="col-sm-5">
                                <img :src="lang.url" style="width: 100%" />
                              </div>
                              <div class="col-sm-5">
                                <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(editorialDetail.modules, item.moduleId, index)"><i class="fa fa-pencil"></i></a>
                              </div>
                            </div>
                            <div class="form-group" v-if="item.moduleId == 5">
                              <label class="col-sm-2 control-label"> Video </label>
                              <div class="col-sm-10">
                                <el-input v-model="lang.url" show-word-limit></el-input>
                              </div>
                            </div>
                            <div class="form-group" v-if="item.moduleId == 4">
                              <label class="col-sm-2 control-label"> Caption </label>
                              <div class="col-sm-10">
                                <el-input v-model="lang.caption" show-word-limit></el-input>
                              </div>
                            </div>
                            <div class="form-group" v-if="item.moduleId == 4">
                              <label class="col-sm-2 control-label"> Alt Text </label>
                              <div class="col-sm-10">
                                <el-input v-model="lang.altText" show-word-limit></el-input>
                              </div>
                            </div>
                            <div class="form-group" v-if="item.moduleId == 4 || item.moduleId == 5 || item.moduleId == 6 || item.moduleId == 7">
                              <label class="col-sm-2 control-label"> Description </label>
                              <div class="col-sm-10">
                                <el-input v-model="lang.description" show-word-limit></el-input>
                              </div>
                            </div>
                            <div v-if="item.moduleId == 6">
                              <div class="form-group margin-0">
                                <label class="col-sm-2 control-label">Images</label>
                                <div class="col-sm-10">
                                  <div class="col-sm-12" style="padding: 0 !important">
                                    <el-form-item
                                      :prop="'modules.' + index + '.urls'"
                                      :rules="{
                                        type: 'array',
                                        min: 2,
                                        required: true,
                                        message: 'Please upload at least two images for this module.',
                                        trigger: 'change',
                                      }"
                                    >
                                      <ul class="sortable-list agile-list">
                                        <li class="" v-for="(url, aa) in item.urls">
                                          <div class="row margin-0" style="padding: 0px !important">
                                            <div class="form-group margin-0">
                                              <label class="col-sm-2 control-label">Image</label>
                                              <div class="col-sm-5">
                                                <img class="pad-t-7" :src="getObject(url.langMap, langItem.langCode).url" style="width: 100%" />
                                              </div>
                                            </div>
                                            <div class="form-group margin-0">
                                              <label class="col-sm-2 control-label">Caption</label>
                                              <div class="col-sm-10">
                                                <div class="pad-t-7" v-html="getObject(url.langMap, langItem.langCode).caption"></div>
                                              </div>
                                            </div>
                                            <div class="form-group margin-0">
                                              <label class="col-sm-2 control-label">Alt Text</label>
                                              <div class="col-sm-10">
                                                <div class="pad-t-7" v-html="getObject(url.langMap, langItem.langCode).altText"></div>
                                              </div>
                                            </div>
                                          </div>
                                          <a class="pull-right btn btn-xs btn-white btnDelete" @click="deleteObj(item.urls, aa)"><i class="fa fa-trash-o"></i></a>
                                          <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(item.urls, 13, aa)"><i class="fa fa-pencil"></i></a>
                                        </li>
                                      </ul>
                                    </el-form-item>
                                  </div>
                                </div>
                                <div class="col-sm-12 text-right">
                                  <div class="btn btn-primary" v-if="item.urls.length < 2" @click="selectModule(item.urls, 13)">Add Image</div>
                                </div>
                              </div>
                            </div>
                            <div v-if="item.moduleId == 7">
                              <div class="form-group margin-0">
                                <label class="col-sm-2 control-label">Images</label>
                                <div class="col-sm-10">
                                  <div class="col-sm-12" style="padding: 0 !important">
                                    <el-form-item
                                      :prop="'modules.' + index + '.urls'"
                                      :rules="{
                                        type: 'array',
                                        min: 3,
                                        required: true,
                                        message: 'Please upload at least 3 images for this module.',
                                        trigger: 'change',
                                      }"
                                    >
                                      <ul class="sortable-list agile-list">
                                        <li class="" v-for="(url, aa) in item.urls">
                                          <div class="row margin-0" style="padding: 0px !important">
                                            <div class="form-group margin-0">
                                              <label class="col-sm-2 control-label">Image</label>
                                              <div class="col-sm-5">
                                                <img class="pad-t-7" :src="getObject(url.langMap, langItem.langCode).url" style="width: 100%" />
                                              </div>
                                            </div>
                                            <div class="form-group margin-0">
                                              <label class="col-sm-2 control-label">Caption</label>
                                              <div class="col-sm-10">
                                                <div class="pad-t-7" v-html="getObject(url.langMap, langItem.langCode).caption"></div>
                                              </div>
                                            </div>
                                            <div class="form-group margin-0">
                                              <label class="col-sm-2 control-label">Alt Text</label>
                                              <div class="col-sm-10">
                                                <div class="pad-t-7" v-html="getObject(url.langMap, langItem.langCode).altText"></div>
                                              </div>
                                            </div>
                                          </div>
                                          <a class="pull-right btn btn-xs btn-white btnDelete" @click="deleteObj(item.urls, aa)"><i class="fa fa-trash-o"></i></a>
                                          <a class="pull-right btn btn-xs btn-white btnEdit" @click="editObj(item.urls, 13, aa)"><i class="fa fa-pencil"></i></a>
                                        </li>
                                      </ul>
                                    </el-form-item>
                                  </div>
                                </div>
                                <div class="col-sm-12 text-right">
                                  <div class="btn btn-primary" v-if="item.urls.length < 20" @click="selectModule(item.urls, 13)">Add Image</div>
                                </div>
                              </div>
                            </div>
                            <div class="form-group" v-if="item.moduleId == 8">
                              <label class="col-sm-2 control-label"> Quote </label>
                              <div class="col-sm-10">
                                <el-input v-model="lang.quote" show-word-limit></el-input>
                              </div>
                            </div>
                            <div class="form-group" v-if="item.moduleId == 8">
                              <label class="col-sm-2 control-label"> Author </label>
                              <div class="col-sm-10">
                                <el-input v-model="lang.author" show-word-limit></el-input>
                              </div>
                            </div>
                          </div>
                          <div class="form-group" v-if="item.moduleId == 9 || item.moduleId == 10">
                            <label class="col-sm-2 control-label"> Event </label>
                            <div class="col-sm-10">
                              <div>
                                <el-form-item
                                  :prop="'modules.' + index + '.event'"
                                  :rules="{
                                    type: 'array',
                                    required: true,
                                    message: $t('message.required'),
                                    trigger: 'change',
                                  }"
                                >
                                  <draggable
                                    class="sortable-list connectList0 agile-list"
                                    style="max-height: 600px; overflow: auto; margin-bottom: 15px"
                                    v-model="item.event"
                                    group="people"
                                    @start="drag = true"
                                    @end="drag = false"
                                  >
                                    <div v-for="(task, index) in item.event" class="dragObj">
                                      <div style="padding: 5px">
                                        <span style="display: inline-block">Name: {{ task["titleen_US"] }}</span>
                                      </div>
                                      <a class="pull-right btn btn-xs btn-white" style="position: absolute; top: 10px; right: 10px" @click="deleteObj(item.event, index)"
                                        ><i class="fa fa-trash-o"></i
                                      ></a>
                                    </div>
                                  </draggable>
                                </el-form-item>
                              </div>
                            </div>
                            <div class="col-sm-12 text-right pad-b-15" v-if="item.event.length == 0">
                              <div class="btn btn-primary" @click="selectEvent(item.event, 0)">Add</div>
                            </div>
                          </div>
                          <div class="form-group" v-if="item.moduleId == 11 || item.moduleId == 12">
                            <label class="col-sm-2 control-label"> POI </label>
                            <div class="col-sm-10">
                              <div>
                                <el-form-item
                                  :prop="'modules.' + index + '.poi'"
                                  :rules="{
                                    type: 'array',
                                    required: true,
                                    message: $t('message.required'),
                                    trigger: 'change',
                                  }"
                                >
                                  <draggable
                                    class="sortable-list connectList0 agile-list"
                                    style="max-height: 600px; overflow: auto; margin-bottom: 15px"
                                    v-model="item.poi"
                                    group="people"
                                    @start="drag = true"
                                    @end="drag = false"
                                  >
                                    <div v-for="(task, index) in item.poi" class="dragObj">
                                      <div style="padding: 5px">
                                        <span style="display: inline-block">Name: {{ task["titleen_US"] }}</span>
                                      </div>
                                      <a class="pull-right btn btn-xs btn-white" style="position: absolute; top: 10px; right: 10px" @click="deleteObj(item.poi, index)"
                                        ><i class="fa fa-trash-o"></i
                                      ></a>
                                    </div>
                                  </draggable>
                                </el-form-item>
                              </div>
                            </div>
                            <div class="col-sm-12 text-right pad-b-15" v-if="item.poi.length == 0">
                              <div class="btn btn-primary" @click="selectPOI(item.poi, 0)">Add</div>
                            </div>
                          </div>
                        </el-collapse-item>
                      </el-collapse>
                      <a class="pull-right btn btn-xs btn-white" style="position: absolute; top: 10px; right: 30px" @click="deleteObj(editorialDetail.modules, index)"><i class="fa fa-trash-o"></i></a>
                    </div>
                  </draggable>
                </div>
                <div class="col-sm-12 text-right pad-b-15">
                  <div class="btn btn-primary" @click="addModule(editorialDetail.modules)">Add module</div>
                </div>
              </div>
              <div class="form-group" v-if="editorialDetail.type == 2">
                <label class="col-sm-2 control-label"> Event Group<span style="color: red">*</span> </label>
                <div class="col-sm-10 dragObj" v-if="editorialDetail.event.id">
                  <label class="control-label">
                    {{ getObject(editorialDetail.event.langMap, langItem.langCode).title }}
                  </label>
                  <a class="pull-right btn btn-xs btn-white btnDelete" @click="editorialDetail.event = {}"><i class="fa fa-trash-o"></i></a>
                </div>
              </div>
              <div class="form-group" v-if="editorialDetail.type == 2">
                <div class="col-sm-12 text-right pad-b-15">
                  <div class="btn btn-primary" @click="addEventGroup">Add Event Group</div>
                </div>
              </div>
              <div class="form-group" v-if="editorialDetail.type == 3">
                <label class="col-sm-2 control-label"> Event<span style="color: red">*</span> </label>
                <div class="col-sm-10 dragObj" v-if="editorialDetail.event.id">
                  <label class="control-label">
                    {{ getObject(editorialDetail.event.langMap, langItem.langCode).title }}
                  </label>
                  <a class="pull-right btn btn-xs btn-white btnDelete" @click="editorialDetail.event = {}"><i class="fa fa-trash-o"></i></a>
                </div>
              </div>
              <div class="form-group" v-if="editorialDetail.type == 3">
                <div class="col-sm-12 text-right pad-b-15">
                  <div class="btn btn-primary" @click="addEvent">Add Event</div>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div
                      class="btn btn-primary"
                      v-if="(!$route.query.id && checkPermission('EDITORIAL_LIST_NEW')) || ($route.query.id && checkPermission('EDITORIAL_LIST_UPDATE'))"
                      @click="checkEvent()"
                    >
                      {{ $t("message.Save") }}
                    </div>
                    <div class="btn btn-white" @click="showWarning()">{{ $t("message.Cancel") }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <el-dialog title="" :visible.sync="selectModuleDlg" width="70%" :append-to-body="true" center>
      <div class="form-group">
        <el-select v-model="module" clearable>
          <el-option v-for="item in modules" :key="item.id" :label="item.content" :value="item.id"> </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="form-group">
          <el-button @click="selectModuleDlg = false">Cancel</el-button>
          <el-button type="primary" @click="addModuleEvent()">Select</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import fileupload from "../components/common/fileupload";
import eventBus from "../eventbus";
import config from "../config";
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import ClassicEditor from "@ckeditor/ckeditor5-build-decoupled-document";
const upload = require("../upload");
import draggable from "vuedraggable";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      editorialDetail: {
        langMap: [
          {
            langCode: "en_US",
            title: "",
          },
          {
            langCode: "zh_CN",
            title: "",
          },
          {
            langCode: "zh_HK",
            title: "",
          },
        ],
        preferencesLink: [],
        modules: [],
        popular: false,
        membershipIds: [],
        location: [],
        type: 1,
        event: {},
      },
      membershipList: [],
      editor: ClassicEditor,
      editorConfig: {
        toolbar: ["Heading", "bold", "italic", "underline", "Link", "bulletedList", "numberedList"],
        // extraPlugins: [ upload.MyCustomUploadAdapterPlugin ]
        // The configuration of the editor.
      },
      selectModuleDlg: false,
      modules: [],
      module: "",
      activeNamesBasis: [],
      locationList: [],
    };
  },
  computed: {
    _language() {
      return this.$store.state.userInfo.langCode;
    },
  },
  watch: {
    _language: function () {
      this.setObj();
    },
    editorialDetail: {
      handler: function (val, oldval) {
        this.$store.state.edit = true;
      },
      deep: true,
    },
  },
  components: {
    draggable,
    "file-upload": fileupload,
  },
  created() {
    this.setObj();
    this.init();
    this.getMembership();
  },
  mounted() {
    setTimeout(function () {
      $(".tab" + 1)
        .parent()
        .find("a")
        .click();

      $(".tab" + 0)
        .parent()
        .find("a")
        .click();
    });
  },
  methods: {
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    },
    setImage(obj, value, item) {
      for (var i = 0; i < obj.length; i++) {
        if (!obj[i][item] && value) {
          obj[i][item] = value;
        }
      }
    },
    setItemIamge(result, item) {
      item.image = result.fullName;
    },
    setObj: function () {
      this.preferencesObj = [
        {
          value: "0",
          label: "Music",
        },
        {
          value: "1",
          label: "Dance",
        },
        {
          value: "2",
          label: "Xiqu",
        },
        {
          value: "3",
          label: "Design & Architecture",
        },
        {
          value: "4",
          label: "Theatre/Drama",
        },
        {
          value: "5",
          label: "Literature",
        },
        {
          value: "6",
          label: "Exhibition",
        },
        {
          value: "7",
          label: "Festivals",
        },
        {
          value: "8",
          label: "Films/Moving Image",
        },
        {
          value: "9",
          label: "Visual Culture",
        },
        {
          value: "10",
          label: "Chinese Art/Culture",
        },
        {
          value: "11",
          label: "Guided Tour",
        },
        {
          value: "12",
          label: "Workshop",
        },
        {
          value: "13",
          label: "Talks/Seminars",
        },
        {
          value: "14",
          label: "Free Events",
        },
        {
          value: "15",
          label: "Family Events",
        },
        {
          value: "16",
          label: "Pet Friendly Activities",
        },
        {
          value: "17",
          label: "Shopping",
        },
        {
          value: "18",
          label: "Dining ",
        },
      ];
      this.statusObj = [
        {
          value: "0",
          label: this.$i18n.t("message.Inactive"),
        },
        {
          value: "1",
          label: this.$i18n.t("message.Active"),
        },
      ];
      this.typeObj = [
        {
          value: 1,
          label: "Editorial",
        },
        {
          value: 2,
          label: "Event Group",
        },
        {
          value: 3,
          label: "Event",
        },
      ];
      this.languageObj = [
        {
          value: "English",
        },
        {
          value: "Cantonese",
        },
        {
          value: "Chinese",
        },
      ];
    },
    async init() {
      let id = this.$route.query.id;
      if (id) {
        let obj = this.getAuthObj();
        obj.editorialId = id;
        obj.apiUrl = "/getEditorialDetail";
        let data = await this.$store.dispatch("apiEvent", obj);
        if (!data) return;
        data.data.result.status += "";
        data.data.result.membershipIds = [];
        if (data.data.result.membershipList) {
          data.data.result.membershipList.forEach(item => {
            data.data.result.membershipIds.push(item.id);
          });
        }
        if (data.data.result.preferencesLink) {
          data.data.result.preferencesLink = data.data.result.preferencesLink.split(",");
        } else {
          data.data.result.preferencesLink = [];
        }
        this.$set(this, "editorialDetail", data.data.result);
        if (!this.editorialDetail.event) {
          this.editorialDetail.event = {};
        }
        if (!this.editorialDetail.location) {
          this.editorialDetail.location = [];
        } else {
          this.editorialDetail.location = this.editorialDetail.location.split(",");
        }
        for (var i = 0; i < this.editorialDetail.modules.length; i++) {
          if (
            this.editorialDetail.modules[i].events &&
            this.editorialDetail.modules[i].events.length > 0 &&
            (this.editorialDetail.modules[i].moduleId == 9 || this.editorialDetail.modules[i].moduleId == 10)
          ) {
            for (var j = 0; j < this.editorialDetail.modules[i].events[0].langMap.length; j++) {
              if (this.editorialDetail.modules[i].events[0].langMap[j].langCode == "en_US") {
                this.editorialDetail.modules[i].events[0]["title" + "en_US"] = this.editorialDetail.modules[i].events[0].langMap[j].title;
              }
              if (this.editorialDetail.modules[i].events[0].langMap[j].langCode == "zh_HK") {
                this.editorialDetail.modules[i].events[0]["title" + "zh_HK"] = this.editorialDetail.modules[i].events[0].langMap[j].title;
              }
              if (this.editorialDetail.modules[i].events[0].langMap[j].langCode == "zh_CN") {
                this.editorialDetail.modules[i].events[0]["title" + "zh_CN"] = this.editorialDetail.modules[i].events[0].langMap[j].title;
              }
            }
            this.editorialDetail.modules[i].event = this.editorialDetail.modules[i].events;
          }
          if (
            (!this.editorialDetail.modules[i].pois || this.editorialDetail.modules[i].pois.length == 0) &&
            (this.editorialDetail.modules[i].moduleId == 11 || this.editorialDetail.modules[i].moduleId == 12)
          ) {
            this.editorialDetail.modules[i].pois = [];
            this.editorialDetail.modules[i].poi = [];
          }
          if (
            this.editorialDetail.modules[i].pois &&
            this.editorialDetail.modules[i].pois.length > 0 &&
            (this.editorialDetail.modules[i].moduleId == 11 || this.editorialDetail.modules[i].moduleId == 12)
          ) {
            for (var j = 0; j < this.editorialDetail.modules[i].pois[0].langMap.length; j++) {
              if (this.editorialDetail.modules[i].pois[0].langMap[j].langCode == "en_US") {
                this.editorialDetail.modules[i].pois[0]["title" + "en_US"] = this.editorialDetail.modules[i].pois[0].langMap[j].name;
              }
              if (this.editorialDetail.modules[i].pois[0].langMap[j].langCode == "zh_HK") {
                this.editorialDetail.modules[i].pois[0]["title" + "zh_HK"] = this.editorialDetail.modules[i].pois[0].langMap[j].name;
              }
              if (this.editorialDetail.modules[i].pois[0].langMap[j].langCode == "zh_CN") {
                this.editorialDetail.modules[i].pois[0]["title" + "zh_CN"] = this.editorialDetail.modules[i].pois[0].langMap[j].name;
              }
            }
            this.editorialDetail.modules[i].poi = this.editorialDetail.modules[i].pois;
          }
        }
        debugger;
        var that = this;
        setTimeout(function () {
          that.$store.state.edit = false;
        });
      } else {
      }
      this.getModule();
      this.getLocation();
    },
    async getModule() {
      var that = this;
      let objdata = this.getAuthObj();
      objdata.apiUrl = "/getModuleList";
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      this.modules = data.data.resultList;
      for (var i = 0; i < this.editorialDetail.modules.length; i++) {
        this.editorialDetail.modules[i].moduleName = this.modules.find(function (item) {
          return item.id == that.editorialDetail.modules[i].moduleId;
        }).content;
      }
    },
    async getLocation() {
      var that = this;
      let objdata = this.getAuthObj();
      objdata.apiUrl = "/getEditorialLocationList";
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      this.locationList = data.data.resultList;
    },
    goBack() {
      this.$router.go(-1);
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        this.goBack();
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.callDelete();
              },
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () {},
            },
          ],
        });
      }
    },
    checkEvent: function () {
      this.$refs["editorialDetail"].validate(valid => {
        if (valid) {
          this.submit();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    async submit() {
      try {
        let obj = this.getAuthObj();
        for (var key in this.editorialDetail) {
          var detail = JSON.stringify(this.editorialDetail[key]);
          obj[key] = JSON.parse(detail);
        }

        obj.langMap = JSON.stringify(obj.langMap);
        for (var i = 0; i < obj.modules.length; i++) {
          if (obj.modules[i].moduleId == 10 || obj.modules[i].moduleId == 9) {
            obj.modules[i].event = obj.modules[i].event[0].id;
            obj.modules[i].events = [];
          }
          if (obj.modules[i].moduleId == 11 || obj.modules[i].moduleId == 12) {
            obj.modules[i].poi = obj.modules[i].poi[0].id;
            obj.modules[i].pois = [];
          }
        }
        obj.membershipIds = obj.membershipIds.join(",");
        obj.location = obj.location.join(",");
        if (obj.event.id) {
          obj.eventId = obj.event.id;
          delete obj.event;
        } else {
          obj.eventId = "";
        }
        if (obj.type != 1 && obj.eventId === "") {
          this.$toastr.w("Please add minimum one event to proceed.");
          return;
        }
        obj.modules = JSON.stringify(obj.modules);
        if (this.$route.query.id) {
          obj.editorialId = this.$route.query.id;
          obj.apiUrl = "/updateEditorial";
          var data = await this.$store.dispatch("apiEvent", obj);
        } else {
          obj.apiUrl = "/createEditorial";
          var data = await this.$store.dispatch("apiEvent", obj);
        }
        if (!data) return;
        if (data.data.errorCode === 0) {
          this.$store.state.edit = false;
          this.goBack();
        }
      } catch (err) {}
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {
      try {
        let obj = this.getAuthObj();
        obj.ids = this.$route.query.id;
        obj.apiUrl = "/deleteEditorial";
        var data = await this.$store.dispatch("apiEvent", obj);
        if (!data) return;
        if (data.data.errorCode === 0) {
          this.$store.state.edit = false;
          this.goBack();
        }
      } catch (err) {}
    },
    langLabel(lang) {
      if (lang === "en_US") {
        return "EN";
      } else if (lang === "zh_HK") {
        return "T. Chi.";
      } else if (lang === "zh_CN") {
        return "S. Chi.";
      }
    },
    changeTab: function (id) {
      $(".tab" + id)
        .parent()
        .find("a")
        .click();
    },
    showTab: function ($event, tabId) {
      $event.preventDefault();
      switch (tabId) {
        case "1":
          $scope.tab1 = true;
          $($event.target).tab("show");
          break;
        case "2":
          $scope.tab2 = true;
          $($event.target).tab("show");
          break;
      }
    },
    addModule: function (obj) {
      this.selectModuleDlg = true;
    },
    addModuleEvent: function () {
      this.selectModule(this.editorialDetail.modules, this.module);
    },
    selectModule: function (obj, objType, index) {
      var that = this;
      if (index != undefined) {
        var data = obj[index];
      } else if (objType == 1 || objType == 2 || objType == 3) {
        var name = this.modules.find(function (item) {
          return item.id == that.module;
        }).content;
        var data = {
          "moduleId": objType,
          "moduleName": name,
          "langMap": [
            {
              langCode: "en_US",
              content: "",
            },
            {
              langCode: "zh_CN",
              content: "",
            },
            {
              langCode: "zh_HK",
              content: "",
            },
          ],
        };
      } else if (objType == 4 || objType == 5) {
        var name = this.modules.find(function (item) {
          return item.id == that.module;
        }).content;
        var data = {
          "moduleId": objType,
          "moduleName": name,
          "langMap": [
            {
              langCode: "en_US",
              "description": "",
              "url": "",
              "caption": "",
              "altText": "",
            },
            {
              langCode: "zh_CN",
              "description": "",
              "url": "",
              "caption": "",
              "altText": "",
            },
            {
              langCode: "zh_HK",
              "description": "",
              "url": "",
              "caption": "",
              "altText": "",
            },
          ],
        };
      } else if (objType == 6 || objType == 7) {
        var name = this.modules.find(function (item) {
          return item.id == that.module;
        }).content;
        var data = {
          "moduleId": objType,
          "moduleName": name,
          "urls": [],
          "langMap": [
            {
              langCode: "en_US",
              "description": "",
            },
            {
              langCode: "zh_CN",
              "description": "",
            },
            {
              langCode: "zh_HK",
              "description": "",
            },
          ],
        };
      } else if (objType == 8) {
        var name = this.modules.find(function (item) {
          return item.id == that.module;
        }).content;
        var data = {
          "moduleId": objType,
          "moduleName": name,
          "langMap": [
            {
              langCode: "en_US",
              "quote": "",
              "author": "",
            },
            {
              langCode: "zh_CN",
              "quote": "",
              "author": "",
            },
            {
              langCode: "zh_HK",
              "quote": "",
              "author": "",
            },
          ],
        };
      } else if (objType == 10 || objType == 9) {
        var name = this.modules.find(function (item) {
          return item.id == that.module;
        }).content;
        var data = {
          "moduleId": objType,
          "moduleName": name,
          "event": [],
        };
        this.selectModuleDlg = false;
        that.module = "";
        obj.push(data);
        return;
      } else if (objType == 12 || objType == 11) {
        var name = this.modules.find(function (item) {
          return item.id == that.module;
        }).content;
        var data = {
          "moduleId": objType,
          "moduleName": name,
          "poi": [],
        };
        this.selectModuleDlg = false;
        that.module = "";
        obj.push(data);
        return;
      } else if (objType == 13) {
        var data = {
          "langMap": [
            {
              langCode: "en_US",
              "url": "",
              "caption": "",
              "altText": "",
            },
            {
              langCode: "zh_CN",
              "url": "",
              "caption": "",
              "altText": "",
            },
            {
              langCode: "zh_HK",
              "url": "",
              "caption": "",
              "altText": "",
            },
          ],
        };
      }
      this.selectModuleDlg = false;

      this.$store.commit("setmodule", {
        obj: data,
        objType: objType,
        boolean: true,
        callback: function () {
          that.$store.commit("setgroup", { string: "", boolean: false });
          that.module = "";
          if (index == undefined) {
            obj.push(data);
          }
        },
      });
    },
    editObj: function (obj, type, index) {
      this.selectModule(obj, type, index);
    },
    deleteObj: function (obj, index) {
      obj.splice(index, 1);
    },
    selectEvent: function (obj, type) {
      var that = this;
      this.$store.commit("seteventlist", {
        callback: function (item) {
          that.$store.commit("seteventlist", { string: "", boolean: false });
          for (var i = 0; i < item.length; i++) {
            var canPush = true;
            for (var j = 0; j < obj.length; j++) {
              if (obj[j].id == item[i].id) {
                canPush = false;
              }
            }
            if (canPush && obj.length == 0) {
              obj.push(item[i]);
            } else {
              that.$toastr.w("Please add a new module for another event addition. ");
            }
          }
        },
        boolean: true,
        both: true,
        button: [],
      });
    },
    selectPOI: function (obj, type) {
      var that = this;
      this.$store.commit("setpoilist", {
        callback: function (item) {
          that.$store.commit("setpoilist", { string: "", boolean: false });
          for (var i = 0; i < item.length; i++) {
            var canPush = true;
            for (var j = 0; j < obj.length; j++) {
              if (obj[j].id == item[i].id) {
                canPush = false;
              }
            }
            if (canPush && obj.length == 0) {
              obj.push(item[i]);
            } else {
              that.$toastr.w("Please add a new module for another POI addition. ");
            }
          }
        },
        boolean: true,
        // source: "Editorial",
        button: [],
      });
    },
    addEvent() {
      var that = this;
      this.$store.commit("seteventlist", {
        callback: function (item) {
          that.$store.commit("seteventlist", { string: "", boolean: false });
          that.editorialDetail.event = item[0];
        },
        boolean: true,
        button: [],
      });
    },
    addEventGroup() {
      var that = this;
      this.$store.commit("seteventgrouplist", {
        callback: function (item) {
          that.$store.commit("seteventgrouplist", { string: "", boolean: false });
          that.editorialDetail.event = item[0];
        },
        boolean: true,
        button: [],
      });
    },
    changeType() {
      this.editorialDetail.event = {};
      this.editorialDetail.modules = [];
    },
    async getMembership() {
      let objdata = this.getAuthObj();
      objdata.sortField = "id";
      objdata.sortType = "ASC";
      objdata.startRow = 0;
      objdata.maxRows = 1000000;
      objdata.apiUrl = "/getMembershipList";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      var memberList = [];
      data.data.resultList.forEach(element => {
        element.membershipName = element.langMap[0].membershipName;
        if (this.$route.query.membershipCategoryId) {
          if (this.$route.query.membershipCategoryId == element.membershipCategoryId) {
            memberList.push(element);
          }
        } else {
          memberList.push(element);
        }
      });
      this.membershipList = memberList;
    },
  },
};
</script>
